import { IBaseParams } from '@interfaces/IBaseParam';
import { callAPIContent } from '@utils/fetcher/content';
import {
  IParamCreateQtyAdjustment,
  IParamGetBinProduct,
  IParamProcessQtyAdjustment,
  IParamRefreshRemainingStock,
  IParamSetStockAlert,
  IParamsTFStockBin,
} from './inventory.types';

export const getStocksInventoryFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'GET',
    servicePath: 'inventory',
    uri: 'stocks',
    params,
  };
  return callAPIContent(options);
};

export const getStocksInventoryByBinFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'GET',
    servicePath: 'inventory',
    uri: 'stocks/bin',
    params,
  };
  return callAPIContent(options);
};

export const getStocksHistoryFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'GET',
    servicePath: 'inventory',
    uri: 'stocks/history',
    params,
  };
  return callAPIContent(options);
};

export const transferStockBinFromAPI = (params: IParamsTFStockBin) => {
  const options = {
    method: 'POST',
    servicePath: 'inventory',
    uri: 'stocks/transfer/bin',
    params,
  };
  return callAPIContent(options);
};

export const getListHistoryQtyAdjusmentFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'GET',
    servicePath: 'inventory',
    uri: 'quantity-adjustments/page',
    params,
  };
  return callAPIContent(options);
};

export const createQtyAdjusmentFromAPI = (
  params: IParamCreateQtyAdjustment,
) => {
  const options = {
    method: 'POST',
    servicePath: 'inventory',
    uri: 'quantity-adjustments',
    params,
  };
  return callAPIContent(options);
};

export const getListBinByProduct = (params: IParamGetBinProduct) => {
  const options = {
    method: 'GET',
    servicePath: 'bin-locations',
    uri: 'page',
    params,
  };
  return callAPIContent(options);
};

export const getInventoryReportFromAPI = () => {
  const options = {
    method: 'GET',
    servicePath: 'inventory',
    uri: 'report',
    params: {},
  };
  return callAPIContent(options);
};

export const exportInventoryFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'POST',
    servicePath: 'inventory',
    uri: 'stocks/export',
    params,
    additionalHeader: {
      'Access-Control-Expose-Headers': 'X-Suggested-Filename',
    },
    additionalConfig: {
      responseType: 'blob',
    },
  };
  return callAPIContent(options);
};

export const getStockAlertFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'GET',
    servicePath: 'inventory',
    uri: 'stocks/alert',
    params,
  };
  return callAPIContent(options);
};

export const setStockAlertFromAPI = (params: IParamSetStockAlert) => {
  const options = {
    method: 'POST',
    servicePath: 'inventory',
    uri: 'stocks/alert',
    params,
  };
  return callAPIContent(options);
};

export const getReportInventoryFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'GET',
    servicePath: 'products',
    uri: 'inventory',
    params,
  };
  return callAPIContent(options);
};

export const importAdjustmentFromAPI = (params: FormData) => {
  const options = {
    method: 'POST',
    servicePath: 'inventory',
    uri: `quantity-adjustments/import/review`,
    params,
    additionalHeader: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return callAPIContent(options);
};

export const processQtyAdjusmentFromAPI = (
  params: IParamProcessQtyAdjustment,
) => {
  const options = {
    method: 'POST',
    servicePath: 'inventory',
    uri: 'quantity-adjustments/import/process',
    params,
  };
  return callAPIContent(options);
};

export const refreshRemainingStockFromAPI = (
  params: IParamRefreshRemainingStock,
) => {
  const options = {
    method: 'PUT',
    servicePath: 'inventory',
    uri: 'stocks/avg',
    params,
  };
  return callAPIContent(options);
};

export const exportInventoryBinFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'GET',
    servicePath: 'inventory',
    uri: 'stocks/bin/export',
    params,
    additionalHeader: {
      'Access-Control-Expose-Headers': 'X-Suggested-Filename',
    },
    additionalConfig: {
      responseType: 'blob',
    },
  };
  return callAPIContent(options);
};

export const getInventoryReportZidoct = (params: IBaseParams) => {
  const options = {
    method: 'GET',
    servicePath: 'inventory',
    uri: 'stocks/zidoct',
    params,
  };
  return callAPIContent(options);
};

export const exportInventoryZidoctFromAPI = (params: IBaseParams) => {
  params.warehouse_id = Number(params?.warehouse_id);
  const options = {
    method: 'POST',
    servicePath: 'inventory',
    uri: 'stocks/zidoct/export',
    params,
    additionalHeader: {
      'Access-Control-Expose-Headers': 'X-Suggested-Filename',
    },
    additionalConfig: {
      responseType: 'blob',
    },
  };
  return callAPIContent(options);
};

export const exportInventoryHistoryFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'POST',
    servicePath: 'inventory',
    uri: 'stocks/history/export',
    params,
    additionalHeader: {
      'Access-Control-Expose-Headers': 'X-Suggested-Filename',
    },
    additionalConfig: {
      responseType: 'blob',
    },
  };
  return callAPIContent(options);
};
